import React, { useEffect } from 'react'
import NavigationBar from '../components/NavigationBar'
import { MDBAccordion, MDBAccordionItem, MDBBreadcrumb, MDBBreadcrumbItem, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import { Link } from 'react-router-dom'
import { Attendance, Bell, Bookinglink, Classmanagement01, Cmanagement, Inmanagements, Leadgeneration, Notifications, PilatesStudio, SocialMedia, textnotification } from '../assets/images/images'
import LandingFooter from '../components/LandingFooter'
import { classFaqs } from '../data/constants'
import ContactUs from '../components/ContactUs'
import RelatedProducts from '../components/RelatedProducts'
import { useNavigate } from 'react-router';
const ClasssLanding = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleDemoClick = () => {
        navigate('/bookademo');
    };
    const handlePricingClick = () => {
        navigate('/commercials');
    };
    return (
        <>
            <NavigationBar classText="blue-logo" from='products' />
            <div className="lp">
                <div className="lp_revenue section-white pt-5">
                    <MDBContainer>
                        <MDBBreadcrumb>
                            <MDBBreadcrumbItem>
                                <Link href='#'>Easymembr</Link>
                            </MDBBreadcrumbItem>
                            <MDBBreadcrumbItem>
                                <Link href='#'>Products</Link>
                            </MDBBreadcrumbItem>
                            <MDBBreadcrumbItem active>Class Management</MDBBreadcrumbItem>
                        </MDBBreadcrumb>


                        <MDBRow className='align-items-center'>
                            <MDBCol sm={12} md={5} lg={5} xl={5}>
                                <h1 className="mm-main-heading text-dark">Class Management:
                                    Simplify Scheduling & Training</h1>
                                <p className="pt-3 text-description">
                                    An all-in-one solution designed to streamline class scheduling, manage instructor assignments, track Training, and provide members with a smooth booking experience.
                                </p>
                                <span class="btn btn-cta trial-button" data-bs-toggle="modal" data-bs-target="#startTrialModal" onClick={handlePricingClick}> Unlock your access</span>

                            </MDBCol>
                            <MDBCol sm={12} md={6} lg={6} xl={6}>
                                <img src={Classmanagement01} alt="Class management interface" width={650} />
                            </MDBCol>
                        </MDBRow>

                        <hr className='pb-5 mt-5' />

                        <h2 style={{ fontSize: "24px" }} className='text-dark'>
                            EasyMembr: Class Management Features
                        </h2>

                        <p>Optimize your scheduling operations and improve Training tracking with the core features of EasyMembr’s Class Management system.</p>

                        <MDBRow>
                            <MDBCol sm={12} md={6} lg={6} className='mb-3 '>
                                <div className='card-v3 h-100'>
                                    <MDBCard className='shadow-0'>
                                        <MDBCardBody className='lp_header'>
                                            <img src={Notifications} alt="" className='card-icon' />
                                            <MDBCardTitle className='my-3 text-dark'>Class Reminders and Notifications</MDBCardTitle>
                                            <div className='lp_small'>Send automated reminders to participants and instructors for upcoming classes. Reduce no-shows and keep your schedule running efficiently.</div>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </MDBCol>

                            <MDBCol sm={12} md={6} lg={6} className='mb-3'>

                                <div className='card-v3'>
                                    <MDBCard className='shadow-0'>
                                        <MDBCardBody className='lp_header'>
                                            <img src={Cmanagement} alt="" className='card-icon' />
                                            <MDBCardTitle className='my-3 text-dark'>Capacity and Waitlist Management</MDBCardTitle>
                                            <div className='lp_small'>Set class limits and enable waitlists to maximize participation without overbooking. Notify members automatically when spots become available.</div>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>



                            </MDBCol>

                            {/* <MDBCol sm={12} md={4} lg={4} className='mb-3'>
                                <div className='card-v3'>
                                    <MDBCard className='shadow-0'>
                                        <MDBCardBody className='lp_header'>
                                            <img src={Attendance} alt="" className='card-icon' />
                                            <MDBCardTitle className='my-3 text-dark'>Attendance Tracking</MDBCardTitle>
                                            <div className='lp_small'>Track attendance in real time. Maintain accurate records for each class and identify patterns in member engagement.</div>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </MDBCol> */}

                            <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                                <div className='card-v3'>
                                    <MDBCard className='shadow-0'>
                                        <MDBCardBody className='lp_header'>
                                            <img src={Inmanagements} alt="" className='card-icon' />
                                            <MDBCardTitle className='my-3 text-dark'>Instructor Management</MDBCardTitle>
                                            <div className='lp_small'>Assign instructors to classes, manage availability, and monitor teaching schedules from a centralized dashboard.</div>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </MDBCol>

                            <MDBCol sm={12} md={6} lg={6} className='mb-3'>
                                <div className='card-v3 h-100'>
                                    <MDBCard className='shadow-0'>
                                        <MDBCardBody className='lp_header'>
                                            <img src={Bookinglink} alt="" className='card-icon' />
                                            <MDBCardTitle className='my-3 text-dark'>Integrated Class Booking Links</MDBCardTitle>
                                            <div className='lp_small'>Create direct booking links for classes. Share them across digital platforms to allow quick and simple registration.</div>
                                        </MDBCardBody>
                                    </MDBCard>
                                </div>
                            </MDBCol>


                        </MDBRow>




                        {/* <h2 style={{ fontSize: "24px" }} className='text-dark mt-4'>
                            Streamlined Class Communication, Scheduling Follow-Ups & Staff Performance Monitoring
                        </h2> */}

                        {/* <p>Strengthen your studio’s scheduling efficiency and operational visibility with EasyMembr’s class communication and staff performance features.</p> */}

                        {/* <MDBRow>
                            <MDBCol sm={12} md={6} lg={6}>
                                <div className="note note-secondary mb-3">
                                    <div style={{ fontSize: "20px" }} className='text-dark fw-600 pb-2'>Automated Class Reminders</div>
                                    <p>
                                        Automatically send timely notifications to members and instructors about upcoming classes. Improve attendance rates and ensure everyone stays informed.
                                    </p>
                                </div>
                            </MDBCol>

                            <MDBCol sm={12} md={6} lg={6}>
                                <div className="note note-secondary mb-3">
                                    <div style={{ fontSize: "20px" }} className='text-dark fw-600 pb-2'>Bulk Communication for Class Announcements</div>
                                    <p>
                                        Send group messages through SMS or WhatsApp to notify members about class schedule changes, cancellations, or special sessions.
                                    </p>
                                </div>
                            </MDBCol>

                            <MDBCol sm={12} md={6} lg={6}>
                                <div className="note note-secondary mb-3">
                                    <div style={{ fontSize: "20px" }} className='text-dark fw-600 pb-2'>Customizable Class Setup</div>
                                    <p>
                                        Configure class types, durations, instructor roles, and participant limits to match your studio’s offerings. Adjust fields to align with your operational needs.
                                    </p>
                                </div>
                            </MDBCol>

                            <MDBCol sm={12} md={6} lg={6}>
                                <div className="note note-secondary mb-3">
                                    <div style={{ fontSize: "20px" }} className='text-dark fw-600 pb-2'>Instructor Performance Tracking</div>
                                    <p>
                                        Measure staff activity based on class attendance, feedback, and scheduling consistency. Use performance reports to support reviews and operational planning.
                                    </p>
                                </div>
                            </MDBCol>
                        </MDBRow> */}


                        <br />

                        <div class="row align-items-center cta-v5 mt-4">
                            <div class="col-md-1">
                                <img src={Bell} alt="Note" class="bell-icon" />
                            </div>
                            <div class="col-md-8">
                                <p>
                                    Request a Demo: See how EasyMembr can make a difference in your studio. Request a live demo and experience the benefits of our software.
                                </p>
                            </div>
                            <div class="col-md-3">
                                <a href="/bookademo" class="cta-button">
                                    Request a Demo!</a>
                            </div>
                        </div>
                        <br />
                        <br />


                        <h2 style={{ fontSize: "24px" }} className='text-dark pt-4'>
                            Explore our FAQ section for details
                        </h2>
                        <p>
                            Software questions, answered
                        </p>


                        <MDBAccordion initialActive={1} borderless>
                            {classFaqs.map((faq) => (
                                <MDBAccordionItem
                                    key={faq.id}
                                    collapseId={faq.id}
                                    headerTitle={faq.title}
                                >
                                    {faq.content.split('\n').map((line, index) => (
                                        <p key={index} style={{ marginBottom: '0.5rem' }}>{line}</p>
                                    ))}
                                </MDBAccordionItem>
                            ))}
                        </MDBAccordion>



                    </MDBContainer>
                </div>


                <div className="section-grey">
                    <ContactUs />
                </div>


            </div>
            <LandingFooter />
        </>
    )
}

export default ClasssLanding
